import { styled } from '@mui/material/styles';

export const HeaderTempStyled = styled('header')<{ variant: 'dark' | 'light' }>`
  position: absolute;
  top: 0;
  left: 50%;
  display: flex;
  width: 100%;
  max-width: 1200px;
  height: 50px;
  padding: 16px 12px;
  transform: translateX(-50%);

  svg {
    fill: ${({ variant }) => (variant === 'dark' ? 'black' : 'white')};
  }
`;

export const LogoBlockStyled = styled('div')`
  display: flex;
  flex-grow: 1;
  justify-content: center;
`;
